define('../src/journeys/j6-sponsors/j6-sponsors1',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J6_SPONSORS = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J6_SPONSORS.prototype.init = function() {
        var _this = this;


        
        this.$journey.css('min-height', Math.max(this.$journey.find('.j4-contact-us--innerbar').outerHeight(true) + 128, ($(window).outerHeight(true) - $('header').outerHeight(true) - $('footer').outerHeight(true))));
    };

    return  J6_SPONSORS;
});

